import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';

import { pageView } from '../Analytics';
import { AnalyticsContext } from '../SiteLayout/SiteLayout';

const TrackCustomPageView = ({
  clearOnUnmount,
  dataLayerVariables,
  pageTitle,
  router,
  children,
}) => {
  const { updateValues } = React.useContext(AnalyticsContext);

  // Set dateLayerVariables and track page view
  React.useEffect(() => {
    pageView(router.asPath, pageTitle);
  }, [updateValues, dataLayerVariables, pageTitle, router.asPath]);

  // Clear data variables on unmount
  React.useEffect(() => {
    const clearDataLayerVariables = () => {
      const newVariables = Object.keys(dataLayerVariables).reduce(
        (object, key) => ({ ...object, [key]: null }),
        {}
      );
      updateValues(newVariables);
    };

    if (clearOnUnmount) {
      window.addEventListener('beforeunload', clearDataLayerVariables);
    }

    return () => {
      if (clearOnUnmount) {
        clearDataLayerVariables();
        window.removeEventListener('beforeunload', clearDataLayerVariables);
      }
    };
  }, [clearOnUnmount, dataLayerVariables, updateValues]);

  return children;
};

TrackCustomPageView.propTypes = {
  clearOnUnmount: PropTypes.bool,
  dataLayerVariables: PropTypes.object,
  pageTitle: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default withRouter(TrackCustomPageView);
